export default __webpack_public_path__ + "static/media/walkthrough.f9001717.svg";